import { useTranslation } from "react-i18next";
import Button from "../Button";
import styles from "./index.module.scss";

const QRInputDisplay = ({ handleScanSumbit, qrCodeUrl, handleRescanQR }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.otpContainer}>
      <form>
        <p className={styles.OTPHeader2fa}>{t("qrInputDisplay.header2fa")}</p>
        {qrCodeUrl.length ? (
          <p className={styles.OTPHeader}>
            {t("qrInputDisplay.qrSubtext")}{" "}
            {t("qrInputDisplay.qrSubtextHelp")}{" "}
            <a href="/guide.pdf" download className={styles.downloadLink}>{t("qrInputDisplay.qrGuide")}</a>
          </p>

        ) : (
          ""
        )}
        <div className={styles.OTPWrapper}>
          {qrCodeUrl.length > 0 ? (
            <img src={qrCodeUrl} alt="BigCo Inc. logo" />
          ) : (
            <p className={styles.inputWrapperError}>
              {t("qrInputDisplay.qrNoUrl")}
            </p>
          )}
        </div>

        <Button
          color="primary"
          style={{ backgroundColor: "#f5b019" }}
          variant="contained"
          fullWidth
          onClick={() => {
            handleScanSumbit();
          }}
        >
          {t("qrInputDisplay.qrGotCode")}
        </Button>
        <span
          style={{ color: "#f5b019", justifyContent: "center", display: "flex", padding: "10px", borderRadius: "5px", marginTop: "10px", cursor: "pointer" }}
          onClick={handleRescanQR}
        >
          {t("qrInputDisplay.qrScanAgain")}
        </span>
      </form>
    </div>
  );
};

export default QRInputDisplay;
